export interface UserForm {
  old_password: string
  password: string
  password_confirmation: string
}

export const initialValues: UserForm = {
  old_password: '',
  password: '',
  password_confirmation: '',
}
